<div class="setup-header">
  <h3>
      {{Translate('Setup Undercarriage In Inventory')}}
  </h3>
</div>
<div class="row">
  <mat-progress-bar *ngIf="_loading" mode="indeterminate" value="50"></mat-progress-bar>
  <mat-horizontal-stepper (selectionChange)="stepChangedManually($event)" [selectedIndex]="_selectedIndex" [linear]="true">
      <mat-step label="{{Translate('Select Equipment')}}">
          <div class="row">
              <div class="col-md-3">
                  <form *ngIf="!_lockModel">
                      <mat-form-field class="setup-form-full-width">
                          <mat-select (selectionChange)="customerChanged($event)" name="customer" [(ngModel)]="_currentSelection.customer" placeholder="{{Translate('Select Customer')}}">
                              <mat-option *ngFor="let customer of _dropDownListsFiltered.customerList" [value]="customer">
                                  {{ customer.Title }}
                              </mat-option>
                          </mat-select>
                      </mat-form-field>
                      <mat-form-field class="setup-form-full-width">
                          <mat-select (selectionChange)="jobsiteChanged($event)" name="jobsite" [(ngModel)]="_currentSelection.jobSite" placeholder="{{Translate('Select Job Site')}}">
                              <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList" [value]="jobsite">
                                  {{ jobsite.Title }}
                              </mat-option>
                          </mat-select>
                      </mat-form-field>

                      <mat-radio-group (change)="updateExistingChanged($event)" name="updateExisting" [(ngModel)]="_updateExisting">
                          <mat-radio-button [value]="false">{{Translate('Create new system')}}</mat-radio-button>
                          <mat-radio-button [value]="true">{{Translate('Update existing')}}</mat-radio-button>
                      </mat-radio-group>

                      <mat-form-field class="setup-form-full-width" *ngIf="_updateExisting" >
                          <mat-select (selectionChange)="systemChanged($event)" name="ucsystem" placeholder="{{Translate('Select System')}}">
                              <mat-option *ngFor="let ucsystem of _dropDownListsFiltered.systemList" [value]="ucsystem">
                                  <!-- <img *ngIf="ucsystem.SystemType == 1" src="/Content/Images/chain.jpg" width="50" alt="Chain" />  -->
                                  <img  *ngIf="!FamilyImage_Chain && ucsystem.SystemType == 1" src="/Content/Images/chain.jpg" width="50" alt="Chain">
                                  <img *ngIf="FamilyImage_Chain && ucsystem.SystemType == 1" [src]="getImage(FamilyImage_Chain)" width="50">

                                  <!-- <img *ngIf="ucsystem.SystemType == 2" src="/Content/Images/frame.jpg" width="50" alt="Frame" /> {{ucsystem.Serial}} -->
                                  <img  *ngIf="!FamilyImage_Frame && ucsystem.SystemType == 2" src="/Content/Images/frame.jpg" width="50" alt="Frame">
                                  <img *ngIf="FamilyImage_Frame && ucsystem.SystemType == 2" [src]="getImage(FamilyImage_Frame)" width="50"> {{ucsystem.Serial}}
                              </mat-option>
                          </mat-select>
                      </mat-form-field>

                      <mat-form-field class="setup-form-full-width" *ngIf="!_updateExisting">
                          <mat-select (selectionChange)="makeChanged($event)" name="__make" placeholder="{{Translate('Select Make')}}" [(ngModel)]="_currentSelection.make">
                              <mat-option *ngFor="let __make of _dropDownLists.makeList" [value]="__make">
                                  {{ __make.Title }}
                              </mat-option>
                          </mat-select>
                      </mat-form-field>

                      <mat-form-field class="setup-form-full-width" *ngIf="!_updateExisting">
                          <mat-select (selectionChange)="modelChanged($event)" name="model" placeholder="{{Translate('Select Model')}}"  [(ngModel)]="_currentSelection.model">
                              <mat-option *ngFor="let model of _dropDownListsFiltered.modelList" [value]="model" >
                                  {{ model.Title }}
                              </mat-option>
                          </mat-select>
                      </mat-form-field>

                  </form>
                  <mat-card color="warning" *ngIf="_lockModel">{{Translate('By changing selection you will lose all your inputs!')}} <button (click)="unlockInputs()" mat-icon-button> {{Translate('Unlock')}} <mat-icon aria="unlock">lock_open</mat-icon></button> </mat-card>
                  <table *ngIf="_currentSelection.system.Id != 0" class="table table-striped">
                      <thead>
                          <tr>
                              <th>
                                  {{Translate('Make')}}
                              </th>
                              <th>
                                  {{Translate('Model')}}
                              </th>
                              <th>
                                  {{Translate('Family')}}
                              </th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                              <td>
                                  {{_currentSelection.system.Make.Title}}
                              </td>
                              <td>
                                  {{_currentSelection.system.Model.Title}}
                              </td>
                              <td>
                                  {{_currentSelection.system.Family.Title}}
                              </td>
                          </tr>
                      </tbody>
                  </table>
              </div>
          </div>
          <!--Step 0-->
          <div class="fix-control-area">
              <a mat-raised-button routerLink="/setup-undercarriage">Cancel</a> <button mat-raised-button color="warn" (click)="nextStep()">{{Translate('Next')}}</button>
              <span class="step-validation-text">
                  <mat-error class="step-error" *ngIf="!StepValidation(0).OperationSucceed">{{StepValidation(0).LastMessage}}</mat-error>
              </span>
          </div>
      </mat-step>
      <!-- <mat-step label="{{Translate('Chain & Frame Details')}}">
          
         
          <div class="fix-control-area">
              <button mat-button matStepperPrevious>{{Translate('Back')}}</button> <button mat-raised-button color="warn" (click)="nextStep()">{{Translate('Next')}}</button>
              <span class="step-validation-text">
                  <mat-error class="step-error" *ngIf="!StepValidation(1).OperationSucceed">{{StepValidation(1).LastMessage}}</mat-error>
              </span>
          </div>
      </mat-step> -->
      <mat-step label="{{Translate('Components')}}">
<!--step two code-->
<mat-radio-group *ngIf=" !_updateExisting && !isCreatingFromAction" name="selectedSystemType" [(ngModel)]="_selectedSystemTypeIsChain">
      <mat-radio-button [value]="true">{{Translate('Chain')}}</mat-radio-button>
      <mat-radio-button [value]="false">{{Translate('Frame')}}</mat-radio-button>
  </mat-radio-group>
  <div class="row box padding-16" *ngIf="_selectedSystemTypeIsChain">
      <div class="col-md-6 setup-on-eq-system-box">
          <!--Left Chain-->
          <div class="row">
              <div class="col-md-3 img-wrap">

                  <img  *ngIf="!FamilyImage_Chain" src="/Content/Images/chain.jpg" alt="Chain">
                      <img *ngIf="FamilyImage_Chain" [src]="getImage(FamilyImage_Chain)">
              </div>
              <div class="col-md-8">
                  <h3 class="colorGreen">
                      {{Translate('Chain')}}
                  </h3>
                  <form>
                      <mat-form-field class="setup-form-full-width" *ngIf="!hideSerial">
                          <input matInput placeholder="{{Translate('Serial Number')}}" name="_leftChainSerial" [(ngModel)]="_leftChainSetup.Serial">
                      </mat-form-field>
                  </form>
              </div>
          </div>
          <div class="row">
              <div class="col-md-12">
                  <form>
                    <div style="display: flex; flex-direction: row; justify-content: space-between;">
                        <mat-form-field class="setup-form-full-width" style="    margin-right: 1%;">
                            <input type="number"   min="1" class="_width_95" matInput placeholder="{{Translate('Life(When cerated in inventory)')}}" name="_leftChainSetupHoursAtInstall" [(ngModel)]="_leftChainSetup.HoursAtInstall" (change)="UpdateLife(1)"><span>{{Translate('Hrs')}}</span>
                        </mat-form-field>

                        <mat-form-field class="setup-form-full-width" style="    margin-right: 1%;" *ngIf="_equipment.Family.Id==177 ||_equipment.Family.Id==203">
                            <input type="number"   min="1" class="_width_95" matInput placeholder="{{Translate('PMU(When cerated in inventory)')}}" name="_leftChainSetupPMUAtInstall" [(ngModel)]="_leftChainSetup.PMUAtInstall" (change)="UpdatePMU(1)"><span>{{Translate('Hrs')}}</span>
                        </mat-form-field>
  
                        <mat-form-field class="setup-form-full-width" style="    margin-right: 1%;">
                          <input type="number"   min="1" class="_width_95" matInput placeholder="{{Translate('SMU/Hourmeter of Equipment at Action Date')}}" name="_SMUHours" [(ngModel)]="SMUHours" required><span>{{Translate('Hrs')}}</span>
                      </mat-form-field>

                      <mat-form-field class="setup-form-full-width" *ngIf="_equipment.Family.Id==177 ||_equipment.Family.Id==203">
                        <input type="number"   min="1" class="_width_95" matInput placeholder="{{Translate('Propel of Equipment at Action Date')}}" name="_PMUHours" [(ngModel)]="PMUHours" required><span>{{Translate('Hrs')}}</span>
                    </mat-form-field>
                    <mat-error *ngIf="ShowError==true">Invalid PMU Reading: PMU(When installed on inventory) cannot be grater than Life(When installed on inventory)</mat-error>
                    </div>
                  </form>
              </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div style="display: flex; flex-direction: row; justify-content: space-between;">
                  <mat-form-field class="setup-form-full-width" style="    margin-right: 1%;">
                      <input matInput (click)="chainPicker.open()" readonly [matDatepicker]="chainPicker" placeholder="Choose a date"
                      [(ngModel)]="_leftChainSetup.InstallationDate"   />
                    <mat-datepicker-toggle matSuffix [for]="chainPicker" ></mat-datepicker-toggle>
                    <mat-datepicker #chainPicker></mat-datepicker>
                    </mat-form-field>
    
                    <mat-form-field  class="setup-form-full-width" style="    margin-right: 1%;">
                        <span matPrefix>$</span>
                        <input type="number"   min="1" class="_width_95" matInput placeholder="{{Translate('Labour Cost')}}" name="_LabourCost" [(ngModel)]="LabourCost">
                    </mat-form-field>
                    <mat-form-field  class="setup-form-full-width">
                        <span matPrefix>$</span>
                        <input type="number"   min="1" class="_width_95" matInput placeholder="{{Translate('Misc Cost')}}" name="_MiscCost" [(ngModel)]="MiscCost">
                    </mat-form-field>
              </div>
                
                
            </div>
            <div class="col-md-12">
            <mat-form-field  class="setup-form-full-width">
                <textarea  class="_width_95" matInput placeholder="{{Translate('Comment')}}" name="_Comment" [(ngModel)]="Comment">
                  </textarea>
            </mat-form-field>
            </div>
        </div>
      </div>
  </div>
  <div class="row" *ngIf="!_selectedSystemTypeIsChain">
      <div class="col-md-6 setup-on-eq-system-box" style="width: 75%;">
          <!--Left Frame-->
          <div class="row">
              <div class="col-md-3 img-wrap">

                  <img  *ngIf="!FamilyImage_Frame" src="/Content/Images/frame.jpg" alt="Left Frame">
                      <img *ngIf="FamilyImage_Frame" [src]="getImage(FamilyImage_Frame)">
              </div>
              <div class="col-md-8">
                  <h3 class="colorGreen">
                      {{Translate('Frame')}}
                  </h3>
                  <form>
                      <mat-form-field class="setup-form-full-width" *ngIf="!hideSerial">
                          <input matInput placeholder="{{Translate('Serial Number')}}" name="_leftFrameSerial" [(ngModel)]="_leftFrameSetup.Serial">
                      </mat-form-field>
                  </form>
              </div>
          </div>
          <div class="row">
              <div class="col-md-12">
                  <form>
                      <!-- <div style="display: flex;">
                          <mat-form-field style="flex: 1; padding-right: 8px;">
                              <input class="_width_95" matInput placeholder="{{Translate('Life(When created in inventory)')}}" name="_leftFrameSetupHoursAtInstall" [(ngModel)]="_leftFrameSetup.HoursAtInstall"><span>{{Translate('Hrs')}}</span>
                          </mat-form-field>
                          <mat-form-field style="flex: 1;">
                              <input class="_width_95" matInput placeholder="{{Translate('Budget Life')}}" name="_leftFrameBudgetLife" [(ngModel)]="_leftFrameSetup.BudgetLife"><span>{{Translate('Hrs')}}</span>
                          </mat-form-field>
                      </div> -->

                      <div style="display: flex; flex-direction: row; justify-content: space-between;">
                          <mat-form-field class="setup-form-full-width" style="    margin-right: 1%;">
                              <input class="_width_95" matInput placeholder="{{Translate('Life(When created in inventory)')}}" name="_leftFrameSetupHoursAtInstall" [(ngModel)]="_leftFrameSetup.HoursAtInstall" (change)="UpdateLife(2)"><span>{{Translate('Hrs')}}</span>
                          </mat-form-field>
                          <mat-form-field class="setup-form-full-width" style="    margin-right: 1%;"  *ngIf="_equipment.Family.Id==177 ||_equipment.Family.Id==203">
                            <input class="_width_95" matInput placeholder="{{Translate('PMU(When created in inventory)')}}" name="_leftFrameSetupPMUAtInstall" [(ngModel)]="_leftFrameSetup.PMUAtInstall" (change)="UpdatePMU(2)"><span>{{Translate('Hrs')}}</span>
                        </mat-form-field>
                          <mat-form-field class="setup-form-full-width" style="    margin-right: 1%;">
                              <input class="_width_95" matInput placeholder="{{Translate('Budget Life')}}" name="_leftFrameBudgetLife" [(ngModel)]="_leftFrameSetup.BudgetLife"><span>{{Translate('Hrs')}}</span>
                          </mat-form-field>
    
                          <mat-form-field class="setup-form-full-width" style="    margin-right: 1%;">
                            <input type="number"   min="1" class="_width_95" matInput placeholder="{{Translate('SMU/Hourmeter of Equipment at Action Date')}}" name="_SMUHours" [(ngModel)]="SMUHours" required><span>{{Translate('Hrs')}}</span>
                        </mat-form-field>
                        <mat-form-field class="setup-form-full-width" *ngIf="_equipment.Family.Id==177 ||_equipment.Family.Id==203">
                            <input type="number"   min="1" class="_width_95" matInput placeholder="{{Translate('Prople Hours of Equipment at Action Date')}}" name="_PMUHours" [(ngModel)]="PMUHours" required><span>{{Translate('Hrs')}}</span>
                        </mat-form-field>
                        <mat-error *ngIf="ShowError==true">Invalid PMU Reading: PMU(When installed on inventory) cannot be grater than Life(When installed on inventory)</mat-error>
                      </div>
                  </form>
              </div>
              
          </div>
          <div class="row">
            <div class="col-md-12">
                    <div style="display: flex; flex-direction: row; justify-content: space-between;">
                        <mat-form-field class="setup-form-full-width">
                            <input matInput (click)="framePicker.open()" readonly [matDatepicker]="framePicker" placeholder="Choose a date"
                            [(ngModel)]="_leftFrameSetup.InstallationDate"   />
                          <mat-datepicker-toggle matSuffix [for]="framePicker" ></mat-datepicker-toggle>
                          <mat-datepicker #framePicker></mat-datepicker>
                          </mat-form-field>
          
                          <mat-form-field  class="setup-form-full-width" style="    margin-right: 1%;">
                              <span matPrefix>$</span>
                              <input type="number"   min="1" class="_width_95" matInput placeholder="{{Translate('Labour Cost')}}" name="_LabourCost" [(ngModel)]="LabourCost">
                          </mat-form-field>
                          <mat-form-field  class="setup-form-full-width">
                              <span matPrefix>$</span>
                              <input type="number"   min="1" class="_width_95" matInput placeholder="{{Translate('Misc Cost')}}" name="_MiscCost" [(ngModel)]="MiscCost">
                          </mat-form-field>
                    </div>

            </div>
            <div class="col-md-12">
                <mat-form-field  class="setup-form-full-width">
                    <textarea  class="_width_95" matInput placeholder="{{Translate('Comment')}}" name="_Comment" [(ngModel)]="Comment">
                      </textarea>
                </mat-form-field>
                </div>
        </div>
      </div>
  </div>
<!--end step two component-->


          <div class="row"  *ngIf="_selectedSystemTypeIsChain">


              <!--Chain components-->
              <div class="col-md-12">
                  <h4>
                      {{Translate('Chain')}}
                  </h4>
                  <p>
                      {{Translate('Please add the components which will go on the chain.')}}
                  </p>
                  <div class="button-row">
                      <button (click)="addComponent(1,230)" [disabled]="checkTemplateForCompartTypeButton(1,230)" mat-raised-button>+ {{Translate('Link')}}</button>
                      <button (click)="addComponent(1,231)" [disabled]="checkTemplateForCompartTypeButton(1,231)" mat-raised-button>+ {{Translate('Bushing')}}</button>
                      <button (click)="addComponent(1,232)" [disabled]="checkTemplateForCompartTypeButton(1,232)" mat-raised-button>+ {{Translate('Shoe')}}</button>
                      <button (click)="addComponent(3,240)" [disabled]="checkTemplateForCompartTypeButton(3,240)" mat-raised-button>+ {{Translate('Track Elongation')}}</button>
                  </div>

                  <div style="padding: 16px">
                    <mat-checkbox [(ngModel)]="bShowAllPartsIds" (change)="ShowPartsIds($event)">Show Parts Ids</mat-checkbox>
                </div> 
                  <div class="row setup-table-row">
                      <div class="setup-component-table-container mat-elevation-z8" style="margin-bottom: 100px;">
                          <mat-table #table [dataSource]="leftchainTableDataSource">
                              <!--- Note that these columns can be defined in any order.
                              The actual rendered columns are set as a property on the row definition" -->
                              <ng-container matColumnDef="delete">
                                  <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                                  <mat-cell *matCellDef="let element">
                                    <button [disabled]="!checkTemplateForCompartRemoveFromList(1,element.Compart.CompartType.Id)"
                                    (click)="removeElement(1,element)" mat-icon-button>

                                    <mat-icon *ngIf="checkTemplateForCompartRemoveFromList(1,element.Compart.CompartType.Id)"  aria-label="close">close</mat-icon>
                                  </button>
                                  <mat-icon class="colorRed  component-status-icon" *ngIf="!validateComponent(1,element).OperationSucceed" aria-label="warning" title="{{validateComponent(1,element).LastMessage}}">warning</mat-icon>
                                  <mat-icon *ngIf="validateComponent(1,element).OperationSucceed" aria-label="success" title="{{validateComponent(1,element).LastMessage}}" class="colorGreenDark component-status-icon">check_circle</mat-icon>
                                 </mat-cell>
                              </ng-container>

                              <!--<ng-container matColumnDef="listPosition">
                                  <mat-header-cell *matHeaderCellDef> {{Translate('No.')}} </mat-header-cell>
                                  <mat-cell *matCellDef="let element"> {{element.listPosition}} </mat-cell>
                              </ng-container>-->

                              <ng-container matColumnDef="Component">
                                  <mat-header-cell *matHeaderCellDef> {{Translate('Type')}} </mat-header-cell>
                                  <mat-cell *matCellDef="let element"> {{ Translate(element.Compart.CompartType.Title)}} </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="Type">
                                  <mat-header-cell *matHeaderCellDef> <span class="colorRed">{{Translate('Component')}}*</span> </mat-header-cell>
                                  <mat-cell *matCellDef="let element">
                                      <mat-form-field>
                                          <!--
                                           <mat-select (selectionChange)="CompartSelected($event, element)" disableRipple [value]="element.Compart.Id" name="cmpart">
                                          -->
                                          <!-- <mat-select (selectionChange)="CompartSelected($event, element)" [ngModel]="shouldSelectDefault(element)" disableRipple>
                                              <mat-option *ngFor="let cmpart of getAvailableCompartListFiltered(element.Compart.CompartType.Id)"  title="{{Translate(cmpart.CompartNote)}}" [value]="cmpart.Id"> {{cmpart.CompartTitle}}</mat-option>
                                          </mat-select> -->


                                          <mat-select (selectionChange)="CompartSelected($event, element)"   [ngModel]="shouldSelectDefault(element)" disableRipple >
                                            <mat-option  style="min-width: max-content;" *ngFor="let cmpart of getAvailableCompartList(element.Compart.CompartType.Id)" title="{{Translate(cmpart.CompartNote)}}" [value]="cmpart.Id">
                                               <!-- {{cmpart.CompartTitle}}   {{cmpart.CompartNote?':':''}} {{  Translate(cmpart.CompartNote)}} -->
                                               <span style="color: #ed5565;"> {{cmpart.CompartTitle}}</span>  <span> {{cmpart.CompartNote?':':''}} {{  Translate(cmpart.CompartNote)}}</span>
                                            </mat-option>
                                        </mat-select>
                                      </mat-form-field>
                                      <mat-chip-list>
                                          <mat-chip title="{{Translate('Number of inspection points')}}" *ngIf="element.Compart.MeasurementPointsNo > 1" color="accent">{{Translate('MP')}}:{{element.Compart.MeasurementPointsNo}}</mat-chip>
                                      </mat-chip-list>
                                  </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="Pos">
                                  <mat-header-cell *matHeaderCellDef></mat-header-cell>
                                  <mat-cell class="position-cell" *matCellDef="let element"> {{showPosition(element)}} </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="Size">
                                  <mat-header-cell *matHeaderCellDef> {{Translate('Size')}} </mat-header-cell>
                                  <mat-cell *matCellDef="let element">
                                      <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                                          <mat-select name="size" (selectionChange)="soheSizeSelected($event,element)" [value]="element.ShoeSize.Id" disableRipple>
                                              <mat-option *ngFor="let size of _availableShoeSizes" [value]="size.Id">{{size.Title}}</mat-option>
                                          </mat-select>
                                      </mat-form-field>
                                  </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="Grouser">
                                  <mat-header-cell *matHeaderCellDef> {{Translate('Grouser')}} </mat-header-cell>
                                  <mat-cell *matCellDef="let element">
                                      <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                                          <mat-select name="grouser" (selectionChange)="grouserSelected($event,element)" disableRipple [value]="element.Grouser.Id">
                                              <mat-option *ngFor="let grouser of _availableGrousers" [value]="grouser.Id">{{grouser.Title}}</mat-option>
                                          </mat-select>
                                      </mat-form-field>
                                  </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="CleanerHoles">
                                <mat-header-cell *matHeaderCellDef> {{Translate('Cleaner Holes')}}  </mat-header-cell>
                                 <mat-cell *matCellDef="let element">
                                     <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                                          <mat-select name="cleanerholes" (selectionChange)="cleanerHolesChange($event,element)" disableRipple [value]="element.HasCleanerHoles == undefind ?0:element.HasCleanerHoles">
                                            <mat-option  [value]=0>Unknown</mat-option>  
                                            <mat-option  [value]=2>No</mat-option>
                                              <mat-option  [value]=1>Yes</mat-option>
                                          </mat-select>
                                      </mat-form-field>
                                  </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="Brand">
                                  <mat-header-cell *matHeaderCellDef> {{Translate('Brand')}} </mat-header-cell>
                                  <mat-cell *matCellDef="let element">
                                      <mat-form-field>
                                          <mat-select disableRipple (selectionChange)="brandSelected($event,element)" [value]="element.Brand.Id" name="make">
                                              <mat-option *ngFor="let make of _availableComponentMakes" [value]="make.Id">{{make.Title}}</mat-option>
                                          </mat-select>
                                      </mat-form-field>
                                  </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="OEMPartNo" *ngIf="bShowAllPartsIds">
                                <mat-header-cell *matHeaderCellDef> {{Translate('OEM Part No')}} </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <mat-form-field>
                                        <input matInput [(ngModel)]="element.OEMPartNo">
                                    </mat-form-field>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="MFRPartNo" *ngIf="bShowAllPartsIds" >
                                <mat-header-cell *matHeaderCellDef> {{Translate('Manufacture Part No')}} </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <mat-form-field>
                                        <input matInput [(ngModel)]="element.MFRPartNo">
                                    </mat-form-field>
                                </mat-cell>
                            </ng-container>
                              <ng-container matColumnDef="BudgetLife">
                                  <mat-header-cell *matHeaderCellDef> {{Translate('Budget Life')}} </mat-header-cell>
                                  <mat-cell *matCellDef="let element">
                                      <mat-form-field>
                                          <input matInput [(ngModel)]="element.BudgetLife">
                                      </mat-form-field>
                                  </mat-cell>
                              </ng-container>


                              <ng-container matColumnDef="HoursAtInstall">
                                  <mat-header-cell *matHeaderCellDef> {{Translate('Hours at install')}}  </mat-header-cell>
                                  <mat-cell *matCellDef="let element">
                                      <mat-form-field class="setup-form-full-width">
                                          <input type="number" matInput [(ngModel)]="element.HoursAtInstall">
                                      </mat-form-field>
                                  </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="PMUAtInstall" *ngIf="_equipment.Family.Id==177 ||_equipment.Family.Id==203"> 
                                <mat-header-cell *matHeaderCellDef> {{Translate('PMU')}}  </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <mat-form-field class="setup-form-full-width">
                                        <input type="number" matInput [(ngModel)]="element.PMUAtInstall">
                                    </mat-form-field>
                                </mat-cell>
                            </ng-container>

                              <ng-container matColumnDef="InstallCost">
                                  <mat-header-cell *matHeaderCellDef> {{Translate('Cost')}}  </mat-header-cell>
                                  <mat-cell *matCellDef="let element">
                                      <mat-form-field class="setup-form-full-width">
                                          <input type="number" matInput [(ngModel)]="element.InstallCost">
                                          <span matPrefix>$&nbsp;</span>
                                          <!-- <span matSuffix>.00</span> -->
                                      </mat-form-field>
                                  </mat-cell>
                              </ng-container>

                              <mat-header-row *matHeaderRowDef="_displayedColumns"></mat-header-row>
                              <mat-row *matRowDef="let row; columns: _displayedColumns;"></mat-row>
                          </mat-table>
                      </div>
                  </div>
              </div>
          </div>
          <div class="row" *ngIf="!_selectedSystemTypeIsChain">
              <!--Frame components-->
              <div class="col-md-12">
                  <h4>
                      {{Translate('Frame')}}
                  </h4>
                  <p>
                      {{Translate('Please add the components which will go on the frame.')}}
                  </p>
                  <div class="button-row">
                      <button (click)="addComponent(3,233)" [disabled]="checkTemplateForCompartTypeButton(3,233)" mat-raised-button>+ {{Translate('Idler')}}</button>
                      <button (click)="addComponent(3,236)" [disabled]="checkTemplateForCompartTypeButton(3,236)" mat-raised-button>+ {{Translate('Sprocket')}}</button>
                      <button (click)="addComponent(3,237)" [disabled]="checkTemplateForCompartTypeButton(3,237)" mat-raised-button>+ {{Translate('Guard')}}</button>
                      <button (click)="addComponent(3,234)" [disabled]="checkTemplateForCompartTypeButton(3,234)" mat-raised-button>+ {{Translate('Carrier Roller')}}</button>
                      <button (click)="addComponent(3,235)" [disabled]="checkTemplateForCompartTypeButton(3,235)" mat-raised-button>+ {{Translate('Track Roller')}}</button>
                      <button (click)="addComponent(3,446)" [disabled]="checkTemplateForCompartTypeButton(3,446)" mat-raised-button>+ {{Translate('Rear Idler')}}</button>

                    </div>
                    <div style="padding: 16px">
                        <mat-checkbox [(ngModel)]="bShowAllPartsIds" (change)="ShowPartsIds($event)">Show Parts Ids</mat-checkbox>
                    </div> 
                  <div class="row setup-table-row">
                      <div class="setup-component-table-container mat-elevation-z8" style="margin-bottom: 100px;">
                          <mat-table #table [dataSource]="leftframeTableDataSource">
                              <!--- Note that these columns can be defined in any order.
                              The actual rendered columns are set as a property on the row definition" -->
                              <ng-container matColumnDef="delete">
                                  <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                                  <mat-cell *matCellDef="let element"><button [disabled]="!checkTemplateForCompartRemoveFromList(3,element.Compart.CompartType.Id)" (click)="removeElement(3,element)" mat-icon-button> <mat-icon *ngIf="checkTemplateForCompartRemoveFromList(3,element.Compart.CompartType.Id)"  aria-label="close">close</mat-icon> </button> <mat-icon class="colorRed component-status-icon" *ngIf="!validateComponent(3,element).OperationSucceed" aria-label="warning" title="{{validateComponent(3,element).LastMessage}}">warning</mat-icon> <mat-icon *ngIf="validateComponent(3,element).OperationSucceed" aria-label="success" title="{{validateComponent(3,element).LastMessage}}" class="colorGreenDark component-status-icon">check_circle</mat-icon> </mat-cell>
                              </ng-container>

                              <!--<ng-container matColumnDef="listPosition">
                                  <mat-header-cell *matHeaderCellDef> {{Translate('No.')}} </mat-header-cell>
                                  <mat-cell *matCellDef="let element"> {{element.listPosition}} </mat-cell>
                              </ng-container>-->

                              <ng-container matColumnDef="Component">
                                  <mat-header-cell *matHeaderCellDef> {{Translate('Type')}} </mat-header-cell>
                                  <mat-cell *matCellDef="let element"> {{Translate(element.Compart.CompartType.Title)}} </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="Type">
                                  <mat-header-cell *matHeaderCellDef> <span class="colorRed">{{Translate('Component')}}*</span> </mat-header-cell>
                                  <mat-cell *matCellDef="let element">
                                      <mat-form-field>

                                         <!--
                                           <mat-select (selectionChange)="CompartSelected($event, element)" disableRipple [value]="element.Compart.Id" name="cmpart">
                                          -->
                                          <mat-select (selectionChange)="CompartSelected($event, element)"   [ngModel]="shouldSelectDefault(element)" disableRipple >
                                            <mat-option  style="min-width: max-content;" *ngFor="let cmpart of getAvailableCompartList(element.Compart.CompartType.Id)" title="{{Translate(cmpart.CompartNote)}}" [value]="cmpart.Id">
                                               <!-- {{cmpart.CompartTitle}}   {{cmpart.CompartNote?':':''}} {{  Translate(cmpart.CompartNote)}} -->
                                               <span style="color: #ed5565;"> {{cmpart.CompartTitle}}</span>  <span> {{cmpart.CompartNote?':':''}} {{  Translate(cmpart.CompartNote)}}</span>
                                            </mat-option>
                                        </mat-select>

                                      </mat-form-field>
                                      <mat-chip-list>
                                          <mat-chip title="{{Translate('Number of inspection points')}}" *ngIf="element.Compart.MeasurementPointsNo > 1" color="accent">{{Translate('MP')}}:{{element.Compart.MeasurementPointsNo}}</mat-chip>
                                      </mat-chip-list>
                                  </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="Pos">
                                  <mat-header-cell *matHeaderCellDef> {{Translate('Position')}} </mat-header-cell>
                                  <mat-cell class="position-cell" *matCellDef="let element"> {{showPosition(element)}} </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="Size">
                                  <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                                  <mat-cell *matCellDef="let element">
                                      <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                                          <mat-select name="size" (selectionChange)="soheSizeSelected($event,element)" [value]="element.ShoeSize.Id" disableRipple>
                                              <mat-option *ngFor="let size of _availableShoeSizes" [value]="size.Id">{{size.Title}}</mat-option>
                                          </mat-select>
                                      </mat-form-field>
                                  </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="Grouser">
                                  <mat-header-cell *matHeaderCellDef>  </mat-header-cell>
                                  <mat-cell *matCellDef="let element">
                                      <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                                          <mat-select name="grouser" (selectionChange)="grouserSelected($event,element)" disableRipple [value]="element.Grouser.Id">
                                              <mat-option *ngFor="let grouser of _availableGrousers" [value]="grouser.Id">{{grouser.Title}}</mat-option>
                                          </mat-select>
                                      </mat-form-field>
                                  </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="CleanerHoles">
                                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                                 <mat-cell *matCellDef="let element">
                                     <mat-form-field *ngIf="element.Compart.CompartType.Id == 232">
                                          <mat-select name="cleanerholes" (selectionChange)="cleanerHolesChange($event,element)" disableRipple [value]="element.HasCleanerHoles == undefind ?0:element.HasCleanerHoles">
                                            <mat-option  [value]=0>Unknown</mat-option>  
                                            <mat-option  [value]=2>No</mat-option>
                                              <mat-option  [value]=1>Yes</mat-option>
                                          </mat-select>
                                      </mat-form-field>
                                  </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="Brand">
                                  <mat-header-cell *matHeaderCellDef> {{Translate('Brand')}} </mat-header-cell>
                                  <mat-cell *matCellDef="let element">
                                      <mat-form-field>
                                          <mat-select disableRipple (selectionChange)="brandSelected($event,element)" [value]="element.Brand.Id" name="make">
                                              <mat-option *ngFor="let make of _availableComponentMakes" [value]="make.Id">{{make.Title}}</mat-option>
                                          </mat-select>
                                      </mat-form-field>
                                  </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="OEMPartNo" *ngIf="bShowAllPartsIds">
                                <mat-header-cell *matHeaderCellDef> {{Translate('OEM Part No')}} </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <mat-form-field>
                                        <input matInput [(ngModel)]="element.OEMPartNo">
                                    </mat-form-field>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="MFRPartNo" *ngIf="bShowAllPartsIds" >
                                <mat-header-cell *matHeaderCellDef> {{Translate('Manufacture Part No')}} </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <mat-form-field>
                                        <input matInput [(ngModel)]="element.MFRPartNo">
                                    </mat-form-field>
                                </mat-cell>
                            </ng-container>
                              <ng-container matColumnDef="BudgetLife">
                                  <mat-header-cell *matHeaderCellDef> {{Translate('Budget Life')}} </mat-header-cell>
                                  <mat-cell *matCellDef="let element">
                                      <mat-form-field>
                                          <input matInput [(ngModel)]="element.BudgetLife">
                                      </mat-form-field>
                                  </mat-cell>
                              </ng-container>


                              <ng-container matColumnDef="HoursAtInstall">
                                  <mat-header-cell *matHeaderCellDef> {{Translate('Hours at install')}}  </mat-header-cell>
                                  <mat-cell *matCellDef="let element">
                                      <mat-form-field class="setup-form-full-width">
                                          <input type="number" matInput [(ngModel)]="element.HoursAtInstall">
                                      </mat-form-field>
                                  </mat-cell>
                              </ng-container>

                              <ng-container matColumnDef="PMUAtInstall" *ngIf="_equipment.Family.Id==177 ||_equipment.Family.Id==203">
                                <mat-header-cell *matHeaderCellDef> {{Translate('PMU')}}  </mat-header-cell>
                                <mat-cell *matCellDef="let element">
                                    <mat-form-field class="setup-form-full-width">
                                        <input type="number" matInput [(ngModel)]="element.PMUAtInstall">
                                    </mat-form-field>
                                </mat-cell>
                            </ng-container>

                              <ng-container matColumnDef="InstallCost">
                                  <mat-header-cell *matHeaderCellDef> {{Translate('Cost')}}  </mat-header-cell>
                                  <mat-cell *matCellDef="let element">
                                      <mat-form-field class="setup-form-full-width">
                                          <input type="number" matInput [(ngModel)]="element.InstallCost">
                                          <span matPrefix>$&nbsp;</span>
                                          <!-- <span matSuffix>.00</span> -->
                                      </mat-form-field>
                                  </mat-cell>
                              </ng-container>

                              <mat-header-row *matHeaderRowDef="_displayedColumns"></mat-header-row>
                              <mat-row *matRowDef="let row; columns: _displayedColumns;"></mat-row>
                          </mat-table>
                      </div>

                      <div style="display: flex; flex-direction: row;margin-left: 2%;" *ngIf="_equipment.Family.Id!=177 &&_equipment.Family.Id!=203">
                        <div style="display: flex; flex-direction: column;" >
                            <label>{{Translate('Frame Configuration')}}</label>
                            <mat-radio-group  name="_leftFrameSetupframeConfig" [(ngModel)]="_leftFrameSetup.frameConfig" (change)="LeftFrameConfigChange($event)">
                                <mat-radio-button [value]="1">{{Translate('Straight')}}</mat-radio-button>
                                <mat-radio-button [value]="2">{{Translate('Toe Out')}}</mat-radio-button>
                            </mat-radio-group>
                        </div>
                                                            
                        <div style="display: flex; flex-direction: column;     margin-left: 15%;" >
                            <label>{{Translate('Cannon Type')}}</label>
                            <mat-radio-group name="_leftFrameSetupcannonType"  [(ngModel)]="_leftFrameSetup.cannonType" (change)="LeftFrameCannonChange($event)">
                                <mat-radio-button [value]="1">{{Translate('Cast')}}</mat-radio-button>
                                <mat-radio-button [value]="2">{{Translate('Fabricated')}}</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                  </div>

                 
              </div>
          </div>
          <div class="fix-control-area">
              <button mat-button matStepperPrevious>{{Translate('Back')}}</button> <button mat-raised-button color="warn" (click)="nextStep()" [disabled]="ShowError==true">{{Translate('Next')}}</button>
              <span class="step-validation-text">
                  <mat-error class="step-error" *ngIf="!StepValidation(2).OperationSucceed">{{StepValidation(2).LastMessage}}</mat-error>
              </span>
          </div>
      </mat-step>
      <mat-step label="{{Translate('Review and Save')}}">
        <div>
            <!--Both-->
            <div class="row box padding-16">
                <div class="col-md-6"  *ngIf="_selectedSystemTypeIsChain">
                    <!--Left Chain-->
                    <div class="row">
                        <div class="col-md-3 img-wrap">
                            <!-- <img src="/Content/Images/chain.jpg" alt="Chain"> -->
                            <img  *ngIf="!FamilyImage_Chain" src="/Content/Images/chain.jpg" alt="Chain">
                            <img *ngIf="FamilyImage_Chain" [src]="getImage(FamilyImage_Chain)">
                        </div>
                        <div class="col-md-8">
                            <h3>
                                {{Translate('Chain')}}
                            </h3>
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <td>
                                            {{Translate('Serial Number')}}
                                        </td>
                                        <td>
                                            {{Translate('Hours at Install')}}
                                        </td>
                                        <td>
                                            {{Translate('Date at Install')}}
                                        </td>
                                        <td>
                                            {{Translate('Equip. SMU/Hourmeter at install')}}
                                        </td>
                                        <td></td>
                                    </tr>
                                </thead>
                                <tbody class="bold">
                                    <tr>
                                        <td>
                                            {{_leftChainSetup.Serial}}
                                        </td>
                                        <td>
                                            {{_leftChainSetup.HoursAtInstall}}
                                        </td>
                                        <td>
                                            {{formatDate(_leftChainSetup.InstallationDate)}}
                                        </td>
                                        <td>
                                            {{_leftChainSetup.SmuAtInstall}}
                                        </td>
                                        <td>
                                            <mat-icon class="colorRed" *ngIf="!_leftChainSetup.Result.OperationSucceed" aria-label="error" title="{{_leftChainSetup.Result.LastMessage}}">error</mat-icon>
                                            <mat-icon class="colorGreenDark" *ngIf="_loading == 0 && _leftChainSetup.Result.OperationSucceed && _leftChainSetup.Id != 0" aria-label="check" title="{{_leftChainSetup.Result.LastMessage}}">check_circle</mat-icon>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <table class="table table-striped table-responsive">
                                <thead>
                                    <tr>
                                        <td>
                                            {{Translate('Type')}}
                                        </td>
                                        <td>
                                            {{Translate('Make')}}
                                        </td>
                                        <td>
                                            {{Translate('Budget Life')}}
                                        </td>
                                        <td>
                                            {{Translate('Hours at install')}}
                                        </td>
                                        <td>
                                            {{Translate('Cost')}}
                                        </td>
                                        <td></td>
                                    </tr>
                                </thead>
                                <tbody>
                                        <tr *ngFor="let component of _leftChainSetup.Components">
                                            <td>
                                                {{Translate(component.Compart.CompartType.Title)}}:{{component.Compart.CompartTitle}}
                                            </td>
                                            <td>
                                                {{component.Brand.Title}}
                                            </td>
                                            <td>
                                                {{component.BudgetLife}}
                                            </td>
                                            <td>
                                                {{component.HoursAtInstall}}
                                            </td>
                                            <td>
                                                {{component.InstallCost}}
                                            </td>
                                            <td>
                                                <mat-icon class="colorRed" *ngIf="!component.Result.OperationSucceed" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">error</mat-icon>
                                                <mat-icon class="colorGreenDark" *ngIf="_loading == 0 && component.Result.OperationSucceed && component.Id != 0" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">check_circle</mat-icon>
                                            </td>
                                        </tr>
                                    </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6"  *ngIf="!_selectedSystemTypeIsChain">
                    <!--Left Frame-->
                    <div class="row">
                        <div class="col-md-3 img-wrap">
                            <img  *ngIf="!FamilyImage_Frame" src="/Content/Images/frame.jpg" alt="Frame">
                            <img *ngIf="FamilyImage_Frame" [src]="getImage(FamilyImage_Frame)">
                        </div>
                        <div class="col-md-8">
                            <h3>
                                {{Translate('Frame')}}
                            </h3>
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <td>
                                            {{Translate('Serial Number')}}
                                        </td>
                                        <td>
                                            {{Translate('Hours at Install')}}
                                        </td>
                                        <td>
                                            {{Translate('Date at Install')}}
                                        </td>
                                        <td>
                                            {{Translate('Equip. SMU/Hourmeter at install')}}
                                        </td>
                                    </tr>
                                </thead>
                                <tbody class="bold">
                                    <tr>
                                        <td>
                                            {{_leftFrameSetup.Serial}}
                                        </td>
                                        <td>
                                            {{_leftFrameSetup.HoursAtInstall}}
                                        </td>
                                        <td>
                                            {{formatDate(_leftFrameSetup.InstallationDate)}}
                                        </td>
                                        <td>
                                            {{_leftFrameSetup.SmuAtInstall}}
                                        </td>
                                        <td>
                                            <mat-icon class="colorRed" *ngIf="!_leftFrameSetup.Result.OperationSucceed" aria-label="error" title="{{_leftFrameSetup.Result.LastMessage}}">error</mat-icon>
                                            <mat-icon class="colorGreenDark" *ngIf="_loading == 0 && _leftFrameSetup.Result.OperationSucceed && _leftFrameSetup.Id != 0" aria-label="check" title="{{_leftFrameSetup.Result.LastMessage}}">check_circle</mat-icon>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <table class="table table-striped  table-responsive">
                                <thead>
                                    <tr>
                                        <td>
                                            {{Translate('Type')}}
                                        </td>
                                        <td>
                                            {{Translate('Make')}}
                                        </td>
                                        <td>
                                            {{Translate('Budget Life')}}
                                        </td>
                                        <td>
                                            {{Translate('Hours at install')}}
                                        </td>
                                        <td>
                                            {{Translate('Cost')}}
                                        </td>
                                        <td></td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let component of _leftFrameSetup.Components">
                                        <td>
                                            {{ Translate(component.Compart.CompartType.Title)}}:{{component.Compart.CompartTitle}}
                                        </td>
                                        <td>
                                            {{component.Brand.Title}}
                                        </td>
                                        <td>
                                            {{component.BudgetLife}}
                                        </td>
                                        <td>
                                            {{component.HoursAtInstall}}
                                        </td>
                                        <td>
                                            {{component.InstallCost}}
                                        </td>
                                        <td>
                                            <mat-icon class="colorRed" *ngIf="!component.Result.OperationSucceed" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">error</mat-icon>
                                            <mat-icon class="colorGreenDark" *ngIf="_loading == 0 && component.Result.OperationSucceed && component.Id != 0" aria-label="error" title="{{Translate(component.Result.LastMessage)}}">check_circle</mat-icon>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

          <div class="fix-control-area">
              <button mat-button matStepperPrevious>{{Translate('Back')}}</button>
              <button mat-raised-button color="warn" *ngIf="!submittedSucessfully" [disabled]="_loading > 0" (click)="nextStep()">{{Translate('Submit')}}</button>
              <!-- <button mat-raised-button color="warn" *ngIf="submittedSucessfully" [disabled]="_loading > 0" (click)="setupNewUC()">{{Translate('Setup new undercarriage')}}</button>
              <button mat-raised-button color="warn" *ngIf="submittedSucessfully && isCreatingFromAction" [disabled]="_loading > 0" (click)="backToAction()">{{Translate('Go back to record action')}}</button> -->
              <span class="step-validation-text">
                  <mat-error class="step-error" *ngIf="!StepValidation(3).OperationSucceed">{{StepValidation(3).LastMessage}}</mat-error>
              </span>
          </div>
      </mat-step>
  </mat-horizontal-stepper>
</div>
